var _rect, _mask, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMachineOnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 1.75,
    width: 16.5,
    height: 20.5,
    rx: 1.75,
    stroke: "#33CC5E",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 4,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 8,
    height: 4,
    rx: 1,
    stroke: "#33CC5E",
    strokeWidth: 3,
    mask: "url(#path-2-inside-1)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 5.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 10.5,
    width: 1,
    height: 2,
    rx: 0.5,
    stroke: "#33CC5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMachineOnIcon);
export default __webpack_public_path__ + "static/media/machine-on-icon.76a9b5d3857bd377acd9c0b7b8b56fc1.svg";
export { ForwardRef as ReactComponent };